// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"2333175d","517":"a21c61c3","774":"6efafa78"}[chunkId] + ".chunk.js";
};